import React from 'react';

// eslint-disable-next-line import/prefer-default-export
export const PromoGridLayout = () => (
  <>
    {/* browser layout */}
    <div
      className="d-none d-md-block position-absolute w-100"
      style={{ maxHeight: '100%', overflow: 'hidden' }}>
      <div className="grid">
        <div className="grid-item" />
        <div className="grid-item" />
        <div className="grid-item" />
        <div className="grid-item" />
        <div className="grid-item" />
        <div className="grid-item" />
        <div className="grid-item" />
        <div className="grid-item" />
        <div className="grid-item" />
        <div className="grid-item" />
        <div className="grid-item" />
        <div className="grid-item" />
        <div className="grid-item" />
        <div className="grid-item" />
        <div className="grid-item" />
        <div className="grid-item" />
        <div className="grid-item" />
        <div className="grid-item" />
        <div className="grid-item" />
        <div className="grid-item" />
        <div className="grid-item" />
        <div className="grid-item" />
        <div className="grid-item" />
        <div className="grid-item" />
      </div>
    </div>

    {/* mobile */}
    <div
      className="d-block d-md-none position-absolute w-100 ps-4"
      style={{ maxHeight: '100%', overflow: 'hidden' }}>
      <div className="grid">
        <div className="grid-item" />
        <div className="grid-item" />
        <div className="grid-item" />
        <div className="grid-item" />
        <div className="grid-item" />
        <div className="grid-item" />
        <div className="grid-item" />
        <div className="grid-item" />
        <div className="grid-item" />
        <div className="grid-item" />
        <div className="grid-item" />
        <div className="grid-item" />
        <div className="grid-item" />
        <div className="grid-item" />
        <div className="grid-item" />
        <div className="grid-item" />
        <div className="grid-item" />
        <div className="grid-item" />
        <div className="grid-item" />
        <div className="grid-item" />
        <div className="grid-item" />
        <div className="grid-item" />
        <div className="grid-item" />
        <div className="grid-item" />
      </div>
    </div>
  </>
);
